module.exports = __webpack_public_path__ + "static/media/sphs (2).af658c94.jpeg";